import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74c6010c&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=74c6010c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_6a4e8631f36538c7428b4f6a46ee29d3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6010c",
  null
  
)

export default component.exports